<template>
    <div>
    <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "location-list"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/location-list.vue